import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import CancellationPolicyServices from "services/CancellationPolicyServices";
import { notifyError, notifySuccess } from "utils/toast";

const useCancellationPolicySubmit = ( type) => {  
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const [dataInput, setDataInput] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const[loading,setLoading] = useState(false);
 

  const {
    trigger,
    register,
    handleSubmit,
    clearErrors,
    formState: { errors },
  } = useForm();


  var myType = type+1
  
  const onSubmit = async () => {
    setLoading(true);
    try {
      const transformedData = dataInput.reduce((acc, curr) => {
        const daysKey = Object.keys(curr).find(key => key.startsWith('days'));
        const percentageKey = Object.keys(curr).find(key => key.startsWith('percentage'));
    
        const days = curr[daysKey];
        const percentage = curr[percentageKey];
    
        acc[days] = percentage;
    
        return acc;
    }, {});
  
    
      const dataValues = {
        policy: transformedData,
      };
  
      setIsSubmitting(true);
      if (myType) {
        const res = await CancellationPolicyServices.updateCancellationPolicy(myType, dataValues);
        setIsUpdate(true);
        notifySuccess(res.message);
        setIsSubmitting(false);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err?.response?.data?.message || err?.message);
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getCancellationPolicyData = async () => {
    try {
      const res = await CancellationPolicyServices.getAllCancellationPolicy(myType);
      if (res && res.status) {

        const policy = res.data.policy;
      
        const FormWholeArray = Object.entries(policy).map(([days, percentage], index) => ({
          [`days_${index}`]: days,
          [`percentage_${index}`]: percentage,
        }));
        setDataInput(FormWholeArray);
  
       
        setSelectedOptions(Object.keys(policy));
      }
    } catch (err) {
      notifyError(err?.response?.data?.message || err?.message);
    }
  };
  
  useEffect(() => {
    if (!isDrawerOpen) {
      setDataInput([]);
      
      setSelectedOptions([]);
      clearErrors();
      return;
    }

    if (myType) {
      getCancellationPolicyData();
    }
    // eslint-disable-next-line
  }, [myType, isDrawerOpen, clearErrors]);

  return {
    register,
    handleSubmit,
    onSubmit,
    trigger,
    errors,
    isSubmitting,
    loading,setLoading,
    selectedOptions,
    setSelectedOptions,
    setDataInput,
    dataInput,
  
  };
};

export default useCancellationPolicySubmit;
